<template>
    <div id="menuResourcesWrapper">
        <!-- 搜索栏 -->
        <div class="search-box">
            <div>
                <Select style="width:300px" v-model="rs_code" @on-change="selectChangeClick">
                    <Option
                        v-for="(item, index) in selectValueOptions"
                        :value="item.con_code + ''"
                        :key="index"
                    >
                        {{ item.con_name }}
                    </Option>
                </Select>
                &nbsp;&nbsp;
                <Input
                    v-model="srv_name"
                    prefix="ios-search-outline"
                    placeholder="请输入服务名称"
                    style="width: 208px; margin-right: 10px;"
                    @on-enter="handleSearchClick"
                />
                <Button type="primary" @click="handleSearchClick">搜索</Button>
            </div>
            <div></div>
        </div>
        <!-- 表格 -->
        <el-table
            :columns="Columns"
            :rowKey="'rs_code'"
            :tableData="tableData"
            :loading="tableLoading"
            :tableHeight="tableHeight"
            @on-btn-click="onBtnClick"
        ></el-table>
        <!-- 分页 -->
        <div class="paging-box">
            <Page
                :total="totalCount"
                @on-change="handlePagingClick"
                :current="page"
                :page-size="12"
            />
        </div>
        <!-- 编辑弹框 -->
        <serve-model
            :currentServeStatus="currentServeStatus"
            :codeValue="codeValue"
            :delateItem="delateItem"
            v-if="currentServeValueStatus"
            @on-serve-click="onServeClick"
        ></serve-model>
        <!-- 审批弹窗 -->
        <approval-task
            :currentApprovalTask="currentApprovalTask"
            :ifJustShowMsg="ifJustShowMsg"
            @cancleApproval="cancleApproval"
            :delateItem="delateItem"
        ></approval-task>
        <!-- 二次确认框 -->
        <Alter
            ref="AlterModal"
            :configData="AlterConfigData"
            @change_ok="PageSrvByFunTypeActionServeDelates"
        ></Alter>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import elementResizeDetectorMaker from 'element-resize-detector'; // 获取元素的高度
import ElTable from '_g/commonComponent/table/elTable.vue';
import addSourceServeModel from '../components/addSourceServeModel.vue';
import approvalTask from '../../../components/commonComponent/approvelModals/approvalTask.vue';
export default {
    components: {
        'el-table': ElTable,
        'serve-model': addSourceServeModel,
        approvalTask,
    },
    data() {
        return {
            srv_name: '',
            tableData: [], // 数据
            Columns: [
                {
                    title: '服务名称',
                    key: 'srv_name',
                    width: 300,
                    render: (h, { columns, row, index }) => {
                        return h(
                            'span',
                            {
                                style: {
                                    textDecoration: 'underline',
                                    color: '#3485FB',
                                },
                                on: {
                                    click: () => {
                                        this.delateItem = row;
                                        this.processing(2);
                                    },
                                },
                            },
                            row.srv_name
                        );
                    },
                },
                {
                    title: '服务描述',
                    key: 'srv_bk_desc',
                    width: 300,
                },
                {
                    title: '服务类型',
                    key: 'serveType',
                    width: 200,
                },
                {
                    title: '服务类名',
                    key: 'srv_class_name',
                },
                {
                    title: '操作',
                    slot: 'iconfont',
                    width: 200,
                    iconClass: [
                        {
                            name: 'ys-iconbianji',
                            code: '编辑',
                            status: 1,
                            Pname: 'resources_serve_tab_edit_btn',
                        },
                        {
                            name: 'ys-iconlajitongbeifen',
                            code: '删除',
                            status: 1,
                            Pname: 'resources_serve_tab_delate_btn',
                        },
                        {
                            name: 'ys-iconshenpiguanli',
                            code: '审批',
                            status: 1,
                            Pname: 'resources_serve_tab_approval__btn',
                        },
                    ],
                },
            ], // 表头
            totalCount: 0, // 总条数
            page: 1,
            tableHeight: 0,

            selectValueOptions: null, // 下拉框数据
            rs_code: '', // 下拉框选中的值
            AlterConfigData: {}, //二次弹框配置数据
            delateItem: null,
            serveType: '', // 服务类型

            // 弹框
            currentServeStatus: false,
            currentServeValueStatus: false,
            codeValue: 1,
            tableLoading: true, // 表格loading
            /* 审批 */
            currentApprovalTask: false,
            ifJustShowMsg: false,
        };
    },
    methods: {
        ...mapActions([
            'ConfigCodeView_qryConfigByType', // 枚举
            'pageSrvByFunTypeActionServe', // 列表
            'PageSrvByFunTypeActionServeDelate', // 删除
        ]),
        // 获取元素的高度
        getElementHeight() {
            let ERD = elementResizeDetectorMaker();
            let _this = this;
            ERD.listenTo(document.getElementById('menuResourcesWrapper'), element => {
                _this.tableHeight = element.offsetHeight - 66 - 60 - 20; // 在该基础上多-20跟分页有间距
            });
        },
        // 操作按钮
        onBtnClick(rowItem, options) {
            switch (options.code) {
                case '编辑':
                    this.delateItem = rowItem;
                    this.processing(1);
                    break;
                case '删除':
                    this.delateItem = rowItem;
                    this.AlterConfigData = {
                        type: 'warning',
                        title: '警告',
                        content: '是否确认删除当前服务资源？',
                    };
                    this.$refs.AlterModal.OpenModal();
                    break;
                case '审批':
                    this.delateItem = rowItem;
                    this.approvalTaskClick();
                    break;
                default:
                    break;
            }
        },
        // 搜索功能
        handleSearchClick() {
            // 重定向
            this.page = 1;
            this.pageSrvByFunTypeActionServes();
        },
        // 分页功能
        handlePagingClick(res) {
            this.page = res;
            this.pageSrvByFunTypeActionServes();
        },
        // 回调
        onServeClick(res) {
            this.currentServeStatus = false;
            this.currentServeValueStatus = false;
        },
        // 编辑以及查看
        processing(code) {
            this.currentServeStatus = true;
            this.currentServeValueStatus = true;
            this.codeValue = code;
        },
        /* 点击审核 */
        approvalTaskClick() {
            this.currentApprovalTask = true;
            this.ifJustShowMsg = false;
        },
        cancleApproval(data) {
            this.currentApprovalTask = data;
            this.pageSrvByFunTypeActionServes();
        },
        // 下拉框值的修改
        selectChangeClick(res) {
            this.rs_code = res;
            this.handleSelectItem();
            // if (!this.rs_code) return;
            this.page = 1;
            this.pageSrvByFunTypeActionServes();
        },
        // 处理下拉框数据
        handleSelectItem() {
            for (let i = 0; i < this.selectValueOptions.length; i += 1) {
                if (this.selectValueOptions[i].con_code === this.rs_code) {
                    this.serveType = this.selectValueOptions[i].con_name;
                }
            }
        },
        // 下拉框查询
        async selectSearchs() {
            try {
                const data = await this.ConfigCodeView_qryConfigByType({
                    start_recd: 1,
                    limit_recd: 1000,
                });
                if (data.request_state) {
                    this.selectValueOptions = data.config_list;
                    this.rs_code = data.config_list[0].con_code;
                    // 获取下拉框值的name
                    this.handleSelectItem();
                    this.pageSrvByFunTypeActionServes();
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 列表
        async pageSrvByFunTypeActionServes() {
            try {
                // 清空
                this.tableData = [];
                this.totalCount = 0;
                this.tableLoading = true;
                const ev = {
                    sup_srvg_code: this.rs_code || '',
                    start_recd: (this.page - 1) * 12,
                    limit_recd: 12,
                    srv_name: this.srv_name,
                };
                const data = await this.pageSrvByFunTypeActionServe(ev);
                if (data.request_state && data.list_info) {
                    let ev = [];
                    for (let i = 0; i < data.list_info.length; i += 1) {
                        let ob = {
                            ...data.list_info[i],
                            serveType: this.serveType,
                        };
                        ev.push(ob);
                    }
                    this.tableData = ev;
                    this.totalCount = data.all_recd;
                    this.$nextTick(() => {
                        this.tableData.map((item, index) => {
                            if (item.flowable_key) {
                                var ysicon = document.getElementsByClassName('ys-iconshenpiguanli');
                                ysicon[index + 1].style.color = '#7e8b9e';
                            }
                        });
                    });
                    this.tableLoading = false;
                }
                this.tableLoading = false;
            } catch (error) {
                console.log(error);
                this.tableLoading = false;
            }
        },
        // 删除
        async PageSrvByFunTypeActionServeDelates() {
            try {
                const data = await this.PageSrvByFunTypeActionServeDelate({
                    srv_name: this.delateItem.srv_name,
                });
                if (data.request_state) {
                    this.$Message.success('删除成功！');
                    // 刷新页面
                    this.page = 1;
                    this.pageSrvByFunTypeActionServes();
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
    mounted() {
        // 获取元素高度
        this.getElementHeight();
        // 获取下拉框资源
        this.selectSearchs();
    },
};
</script>
<style lang="less" scoped>
#menuResourcesWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
        width: 100%;
        height: 66px;
        padding: 22px 0px 12px 0px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
    }

    .paging-box {
        position: fixed;
        bottom: 0px;
        right: 50px;
        z-index: 1;
        height: 60px;
        width: calc(100% - 250);
        // background-color: #29364e;
        text-align: right;
    }
}
</style>
